import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import TermsOfUse from "../views/Terms.vue";
import PrivacyPolicy from "../views/Privacy.vue";
import Help from "../views/Help.vue";
import LegalPage from "../views/Legal.vue";
import CompliancePage from "../views/Compliance.vue";
import Profile from "../views/Profile.vue";
import NotFound from "../views/NotFound.vue";
import Invite from "../views/Invite.vue";
import { applyRouteSeo } from "../seo";
import { authState, waitForAuth } from "../stores/authStore";
import { trackEvent } from "../firebase";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/terms",
    name: "TermsOfUse",
    component: TermsOfUse,
  },
  {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
  },
  {
    path: "/legal",
    name: "LegalPage",
    component: LegalPage,
  },
  {
    path: "/help",
    name: "Help",
    component: Help,
  },
  {
    path: "/compliance",
    name: "CompliancePage",
    component: CompliancePage,
  },
  {
    path: "/signin",
    name: "SignIn",
    component: () => import("../views/SignIn.vue"),
    meta: { noIndex: true, hideFromNav: true },
  },
  {
    path: "/note/:id",
    name: "NoteDetail",
    component: () => import("../views/NoteDetail.vue"),
    meta: { noIndex: true, hideFromNav: true, hideGlobalLogo: true, requiresAuth: true },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { noIndex: true, hideFromNav: true, hideGlobalLogo: true, requiresAuth: true },
  },
  {
    path: '/app-ads.txt',
    name: 'AppAdsTxt',
    beforeEnter: () => {
      window.location.href = '/app-ads.txt';
    },
  },
  {
    path: "/invite/:code",
    name: "Invite",
    component: Invite,
    meta: { noIndex: true, hideFromNav: true },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: { noIndex: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    // Ancres in-page (#features, #faq…) : scroller vers la section visée
    // au lieu du top — sinon chaque clic d'ancre "remontait" la page.
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    }

    return { top: 0, left: 0, behavior: "smooth" };
  },
});

router.beforeEach(async (to) => {
  if (to.meta && to.meta.requiresAuth) {
    if (authState.isLoading) {
      await waitForAuth();
    }
    if (!authState.isAuthenticated) {
      return { path: "/signin", replace: true };
    }
  }
  return true;
});

router.afterEach((to) => {
  applyRouteSeo(to);
  trackEvent("page_view", {
    page_path: to.fullPath,
    page_location: typeof window !== "undefined" ? window.location.href : undefined,
    page_title: typeof document !== "undefined" ? document.title : undefined,
  });
});

applyRouteSeo(router.currentRoute.value);

export default router;
